import type { Language } from "../../contexts/LanguageContext";

export const clientsLabels: Record<Language, {
  title: string;
  stats: { registered: string; active: string };
  actions: { new: string; open: string };
  search: { label: string; placeholder: string };
  loading: string;
  none: string;
  noneFound: string;
  birthdays: {
    title: string;
    loading: string;
    none: string;
    whatsapp: string;
  };
  form: {
    title: string;
    description: string;
    back: string;
    name: string;
    email: string;
    phone: string;
    cpf: string;
    cancel: string;
    submit: string;
    saving: string;
    requiredName: string;
    success: string;
    genericError: string;
  };
}> = {
  pt: {
    title: "Clientes",
    stats: { registered: "Clientes cadastrados", active: "Clientes ativos" },
    actions: { new: "Novo cliente", open: "Abrir" },
    search: { label: "Buscar por nome, telefone ou CPF", placeholder: "Buscar" },
    loading: "Carregando...",
    none: "Nenhum cliente cadastrado.",
    noneFound: "Nenhum cliente encontrado.",
    birthdays: {
      title: "Próximos aniversariantes",
      loading: "Carregando...",
      none: "Nenhum aniversário nos próximos 7 dias.",
      whatsapp: "Abrir WhatsApp",
    },
    form: {
      title: "Novo cliente",
      description: "Preencha os dados básicos para cadastrar um novo cliente.",
      back: "Voltar",
      name: "Nome",
      email: "Email",
      phone: "Telefone",
      cpf: "CPF / CNPJ",
      cancel: "Cancelar",
      submit: "Cadastrar",
      saving: "Cadastrando...",
      requiredName: "Informe o nome do cliente.",
      success: "Cliente criado com sucesso.",
      genericError: "Não foi possível criar o cliente.",
    },
  },
  en: {
    title: "Clients",
    stats: { registered: "Registered clients", active: "Active clients" },
    actions: { new: "New client", open: "Open" },
    search: { label: "Search by name, phone or CPF", placeholder: "Search" },
    loading: "Loading...",
    none: "No clients registered.",
    noneFound: "No clients found.",
    birthdays: {
      title: "Upcoming birthdays",
      loading: "Loading...",
      none: "No birthdays in the next 7 days.",
      whatsapp: "Open WhatsApp",
    },
    form: {
      title: "New client",
      description: "Fill in the basic information to register a new client.",
      back: "Go back",
      name: "Name",
      email: "Email",
      phone: "Phone",
      cpf: "CPF / CNPJ",
      cancel: "Cancel",
      submit: "Create",
      saving: "Creating...",
      requiredName: "Please provide the client's name.",
      success: "Client created successfully.",
      genericError: "We couldn't create the client.",
    },
  },
};

